import api from "../../index";

export const GetTaskWiseOrganizerApi = (data) => api.post('task-wise-org', data);
export const GetOrganizerAnswerApi = (data) => api.post('org-wise-answer-list', data);
export const ReviewAnswerApi = (data) => api.post('answerreviewcheck', data);
export const GetInvoiceListApi = () => api.post('invoicetemplatelist');
export const DeleteInvoiceApi = (data) => api.post('remove-invoice-request', data);
export const SendInvoiceApi = (data) => api.post('send-invoice', data);
export const ExtraInvoiceSendApi = (data) => api.post('extra-invoice-send', data);
export const UnsubmitOrganizerApi = (data) => api.post('unsubmit-organizer', data);
export const UnsubmitOrganizerTaxApi = (data) => api.post('unsubmit-organizer-tax', data);
export const FileTaxApi = (data) => api.post('submit-tax-file', data);  // Task-2
export const CompleteViewPrepareTaxApi = (data) => api.post('task2-submit', data);  // Task-2
export const CompleteReviewTaxApi = (data) => api.post('review-tax', data);  // Task-3
export const ForceCompleteReviewTaxApi = (data) => api.post('task3-submit', data);  // Task-3
export const CompleteFollowUpApi = (data) => api.post('chatcreate', data);  // Task-4
export const CompleteFollowUpTaskApi = (data) => api.post('task4-submit', data);  // Task-4
export const CompleteReturnToGovApi = (data) => api.post('return-to-gov', data);  // Task-5 

export const SendOrganizerPdfApi = (data, headers) => api.post('send-organizer-pdf', data, headers);

export const ResenOrganizerPdf = (data) => api.post('resend-org-pdf', data);
export const DeleteSignature = (data) => api.post('remove-sign-request', data);
export const AutoPaymentApprovedApi =  (data) => api.post('auto-payment-approved',data);
